import { FileType } from '@office-start/document-types';
import { canOpenInWac, getWdOrigin, shouldAddLoginHintToUrl, } from '@office-start/file-utility';
import { createGuid } from '@office-start/guid-generator';
import { mapWorkloadToHarmonySessionSource } from '@office-start/instrumentation-service';
import { HarmonySessionKey, HarmonySessionSourceKey, } from '@office-start/instrumentation-types';
import { OfficeDotComOrigin, } from '@office-start/officehome-types';
import { appendLoginHint } from '@office-start/url-parser-utility';
export function getDocumentLaunchUrlAndClickId(contentLaunchParams, getCurrentRoute, officeWorkload, officeMarket, sessionId, loginHint, isMsa) {
    var document = contentLaunchParams.document, useWebUrl = contentLaunchParams.useWebUrl, useDeeplinkUrl = contentLaunchParams.useDeeplinkUrl, wdOriginType = contentLaunchParams.wdOriginType;
    var url = new URL((useWebUrl && document.webUrl) ||
        (useDeeplinkUrl && document.deepLinkUrl) ||
        document.url);
    if (loginHint && shouldAddLoginHintToUrl(document)) {
        url = new URL(appendLoginHint(url.href, loginHint, shouldAddLoginHintToUrl(document)));
    }
    var clickId;
    if (canOpenInWac(document)) {
        var clickTime = Date.now();
        clickId = createGuid();
        var officeRouteItem = getCurrentRoute();
        var wdOrigin = getWdOrigin(officeWorkload, officeRouteItem, wdOriginType);
        url.searchParams.set('ct', clickTime.toString());
        url.searchParams.set('wdOrigin', wdOrigin);
        if (!isMsa) {
            url.searchParams.set('cid', clickId);
        }
        url.searchParams.set(HarmonySessionSourceKey, mapWorkloadToHarmonySessionSource(officeWorkload));
        url.searchParams.set(HarmonySessionKey, sessionId);
    }
    else if (document.fileType === FileType.Forms) {
        // TODO: Validate encoding
        var officeRouteItem = getCurrentRoute();
        url.searchParams.set('lang', officeMarket);
        url.searchParams.set('origin', OfficeDotComOrigin);
        url.searchParams.set('route', (officeRouteItem && officeRouteItem.route) || '');
        url.searchParams.set('sessionId', sessionId);
    }
    else if (document.fileType === FileType.Stream ||
        document.fileType === FileType.Audio) {
        url.searchParams.set('web', '1');
        url.searchParams.set('referrer', 'OfficeHome.Web');
        url.searchParams.set('referrerScenario', wdOriginType);
    }
    else if (document.fileType === FileType.Clipchamp) {
        url.searchParams.set('referrer', 'OfficeHome');
        url.searchParams.set('referrerScenario', wdOriginType);
    }
    return [url.toString(), clickId];
}
//# sourceMappingURL=getDocumentLaunchUrlAndClickId.js.map